import { useContext, useMemo } from 'react'
import { EditPanelFieldComponentProps } from '..'
import { EditPanelFieldContext } from '../../contexts/field'
import { EditPanelContext } from '../../contexts/panel'
import { supportedContentTypesFromField } from '../../utilities/field'
import { sharedContentTypeFromGifs } from '../../utilities/gifs'
import { hasFieldPermission } from '../../utilities/permissions'
import CtaInput from './cta'
import UrlInput from './url'

export default ({ className, field, ...props }: EditPanelFieldComponentProps) => {
    const { gifs, permissions } = useContext(EditPanelContext)
    const { isCtaOn } = useContext(EditPanelFieldContext)
    const contentType = sharedContentTypeFromGifs(gifs)

    const showCTA = useMemo(() => {
        if (!isCtaOn) {
            return false
        }

        if (!hasFieldPermission('cta', permissions)) {
            return false
        }

        return supportedContentTypesFromField('cta').indexOf(contentType) > -1
    }, [contentType, isCtaOn, permissions])

    return (
        <>
            <UrlInput {...props} className={className} field={field} />
            {showCTA && <CtaInput {...props} field="cta" />}
        </>
    )
}
